Bingo.AutoNumeric = {};
Bingo.AutoNumeric.init = function (selector, options) {
    if (options == null) {
        options = {
            maximumValue: '9999999999999',
            minimumValue: '-9999999999999',
            decimalCharacter: '.',
            digitGroupSeparator: ' ',
            decimalPlaces: 0,
        };
    }
    const inputs = $(selector);
    inputs.each((index, item) => {
        const input = $(item);

        if ($(`[name="${input.attr('name')}_proxy"]`).length) {
            return;
        }

        // create proxy
        let proxy = input.clone();
        proxy.attr('id', null);

        const originalName = input.attr('name');
        const proxyName = `${originalName}_proxy`;

        proxy.type = 'text';
        proxy.attr('name', proxyName);
        proxy.attr('data-nette-rules', null);
        proxy.attr('id', input.attr('id'));
        // install it
        input.parent().prepend(proxy);
        input.removeAttr('placeholder'); // this prevent IE to submit value of placeholder when field is empty
        input.attr('type', 'hidden');
        input.attr('id', null);
        // ensure that focusing hidden field focus the proxy field
        input[0].focus = function () {
            const focused = document.activeElement;
            $(focused).focusout();
            proxy.focus();
        };
        // initialize autoNumeric
        proxy = $(proxy);
        proxy.each((i, element) => {
            const anElement = new AutoNumeric(element, options);
            anElement.set(input.val());
        });
        proxy.parents('.form-group').addClass('form-group-autonumeric');
        proxy.bind('keypress keyup change', (e) => {
            if (e.type === 'change' || e.keyCode === 13) {
                const anElement = AutoNumeric.getAutoNumericElement(e.target);
                if (anElement) {
                    input.val(anElement.getNumericString());
                    input.change();
                }
            }
        });

        // There is a bug when user selects value from autocomplete. Selected value is not propagated to autonumeric.
        // https://github.com/autoNumeric/autoNumeric/issues/536
        // So turn off autocomplete till it will be fixed.
        proxy.attr('autocomplete', 'off');
    });
};
Bingo.AutoNumeric.setVal = function (proxy, val) {
    $(proxy).each((index, item) => {
        const anElement = AutoNumeric.getAutoNumericElement(item);

        if (anElement === null) {
            return;
        }

        $(item).closest('.form-group').removeClass('is-empty');
        anElement.set(val);
    });
};
